import CustomTabs from '@/components/desktop/CustomTabs';
import SearchFlightTab from '@/containers/Desktop/SearchFlightTabVcms';
import SearchBusTab from '@/containers/Bus/SearchBusTab/desktop';
import SearchTrainTab from '@/containers/SearchTrainTab/desktop';
import FlightIcon from '@mui/icons-material/Flight';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { useDispatch } from 'react-redux';
import { setCalendarType } from '@/slices/calendar/calendarSlice';
import { FC } from 'react';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const Container = styled(Box)`
  position: relative;
`;

interface LandingPageProps {
  title?: string;
  titleComponent?: string;
  filterAirline?: any
  onSearchClick?: () => void;
  lang?: ILangObj;
  isFirstTime?: boolean;
  startPoint: any,
  toPoint: any,
  switchUpdateSecondTime: any;
  statePassenger: any;
  stateSeatClass: any;
}

const LandingPageVcms: FC<LandingPageProps> = ({
  title, titleComponent, filterAirline, onSearchClick, lang, isFirstTime, startPoint, toPoint, switchUpdateSecondTime, statePassenger,
  stateSeatClass,
}) => {
  const dispatch = useDispatch();

  return (
    <Container sx={{
      height: {
        xs: '400px',
        lg: '220px',
      },
    }}
    >
      <CustomTabs
        lang={lang}
        seoStyle
        onClickTab={(newTab: string) => {
          dispatch(setCalendarType({ calendarType: newTab as any }));
        }}
        labelObjs={[
          {
            type: 'flight',
            icon: <div style={{ transform: 'translateX(25%) rotate(45deg) translateY(25%)' }}><FlightIcon /></div>,
          },
        ]}
        tabComponent={[<SearchFlightTab
          // filterAirline={filterAirline}
          onSearchClick={onSearchClick}
          key={1}
          isVcms
          lang={lang}
          isFirstTime={isFirstTime}
          startPoint={startPoint}
          toPoint={toPoint}
          switchUpdateSecondTime={switchUpdateSecondTime}
          statePassenger={statePassenger}
          stateSeatClass={stateSeatClass}
        />, <SearchBusTab
          key={2}
        />, <SearchTrainTab
          key={3}
        />]}
      />
    </Container>
  );
};
export default LandingPageVcms;
